export default "__VITE_ASSET__CxoSMuSu__"